import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Select,
  Box,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import BackButton from 'src/components/BackButton';
import SuccessButton from 'src/components/SuccessButton';
import { formatDate } from 'src/utils/formatTime';
import { getCustomerEnvironmentApplicationStatusOptions } from 'src/utils/enums/customerEnvironmentApplicationStatus';

const STATUS_OPTIONS = getCustomerEnvironmentApplicationStatusOptions();

const StatusUpdateModal = ({
  open,
  onClose,
  currentStatus,
  currentNote,
  currentDate,
  onSave,
  loading,
}) => {
  const [newStatus, setNewStatus] = useState(currentStatus || '');
  const [note, setNote] = useState(currentNote || '');

  useEffect(() => {
    if (open) {
      setNewStatus(currentStatus || '');
      setNote(currentNote || '');
    }
  }, [currentStatus, currentNote, open]);

  const handleSave = () => {
    onSave(newStatus, note.trim());
  };

  const hasStatusChanged = newStatus !== (currentStatus || '');
  const hasNoteChanged = note.trim() !== (currentNote || '').trim();
  const saveDisabled = loading || !(hasStatusChanged || hasNoteChanged);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Status and Note</DialogTitle>

      <DialogContent>
        <Box mt={2}>
          <Typography mb={1}>Last Updated</Typography>
          <Typography variant="body2">{currentDate ? formatDate(currentDate) : '-'}</Typography>
        </Box>

        <Box mt={2}>
          <Typography mb={1}>Status</Typography>
          <Select
            size="small"
            fullWidth
            value={newStatus}
            onChange={e => setNewStatus(e.target.value)}>
            {STATUS_OPTIONS.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </Box>

        <Box mt={2}>
          <Typography mb={1}>Note</Typography>
          <TextField
            size="small"
            fullWidth
            value={note}
            onChange={e => setNote(e.target.value)}
            placeholder="Enter note"
            multiline
            minRows={2}
            maxRows={4}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <BackButton disabled={loading} onClick={onClose}>
          Close
        </BackButton>
        <SuccessButton disabled={saveDisabled} onClick={handleSave} loading={loading}>
          Save
        </SuccessButton>
      </DialogActions>
    </Dialog>
  );
};

export default StatusUpdateModal;